import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/tablet/1_green/1_green"
 * Contains 1 texture(s)
 */
export class Tablet1GreenAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/tablet/1_green/1_green';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '1_green.png'
    ] as const;
}
